import React from "react";
import T from "prop-types";

import { CardPlaceholder } from "2g-cards";

import { PATHS } from "b2b/constants";

function ProvozniInformacePlaceholder({ pocet = 5 }) {
  const placeholders = [];
  for (var i = 0; i < pocet; i++) {
    placeholders.push(
      <CardPlaceholder key={i} imageSrc={PATHS.IMAGES.noImage()} />
    );
  }
  return placeholders;
}

ProvozniInformacePlaceholder.propTypes = {
  pocet: T.number
};

export default React.memo(ProvozniInformacePlaceholder);
